import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMensagens(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('mensagens', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMensagem(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`mensagens/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
}
